<template>
    <div>
        <emc-table-items
            :headers="headers"
            v-bind:params.sync="params"
            v-bind:collections.sync="items"
            v-bind:meta.sync="meta"
            v-bind:itemEdit.sync="itemSelected"
            :loading="loading"
            :find="false"
            :showDelete="false"
            :hideEdit="true"
        >
            <template v-slot:item.signed_at="{ item }">
                <span v-if="item.term_signature_status_id == 2">{{ item.updated_at | dateTime }}</span>
            </template>

            <template v-slot:item.situation="{ item }">
                {{ item.status.name }}
                <small v-if="item.term_signature_status_id != 1">
                    <br/>
                    <span v-if="item.term.is_required">
                        <span v-if="item.agree">{{ item.term.label }}</span>
                    </span>
                    <span v-else>
                        <span v-if="item.option">{{ item.option.label }}</span>
                    </span>
                </small>
            </template>

            <template v-slot:item.digital_signature_info="{ item }">
                <sys-term-digital-signature-status :status="item.digital_signature_status" x-small />
            </template>

            <template v-slot:actions="{ item }">
                <emc-table-icon-download-pdf
                    v-if="item.term_signature_status_id != 1"
                    toolTip="Download do Termo"
                    :route="token ? 'teachers/token/' + token + '/' + item.id + '/pdf-download/teacher-term-signature' : null"
                    type="teacher-term-signature"
                    :token="token"
                    :item="item"
                    :disabled="item.term_signature_status == 1 || !item.url_document"
                />
                <emc-table-icon-edit
                    :tool-tip="item.term_signature_status_id == 1 ? 'Assinar Termo' : 'Visualizar Termo'"
                    :color="item.term_signature_status_id == 1 ? 'success' : 'purple'"
                    @click="itemSelected = item; showForm = true"
                    :icon="item.term_signature_status_id == 1 ? 'mdi-file-document-edit' : 'mdi-text-box-search-outline'"
                />
            </template>
        </emc-table-items>

        <sys-register-term-signature-form
            :view="itemSelected.term_signature_status_id != 1"
            :show.sync="showForm"
            :token="token"
            :signature-id="itemSelected.id"
            @onCompleted="getData()"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'SysTeacherTermSignature',
    data: () => ({
        items: [],
        meta: {},
        params: {},
        loading: true,
        showForm: false,
        itemSelected: { id: 0 },
        headers: [
            { text: 'Termo', value: 'term.name' },
            { text: 'Data', value: 'signed_at', align: 'center' },
            { text: 'Status', value: 'situation', align: 'center' },
            { text: 'Assinatura Digital', value: 'digital_signature_info', align: 'center', sortable: false },
            { text: 'Ações', value: 'actions', align: 'center', sortable: false },
        ],
    }),
    props: {
        teacher: {
            required: true,
        },
        token: {
            type: String,
            default: null,
        },
    },
    methods: {
        ...mapActions('teacher', ['ActionFindTeacher', 'ActionFindTeacherByToken']),

        getData() {
            if (this.teacher.id === undefined) {
                return;
            }

            this.showForm = false;
            this.items = [];
            this.loading = true;

            const action = this.token ? 'ActionFindTeacherByToken' : 'ActionFindTeacher';

            const payload = {
                with: 'termSignatures.term,termSignatures.status,termSignatures.option,termSignatures.digitalSignature',
            };

            if (this.token) {
                payload.token = this.token;
            } else {
                payload.id = this.teacher.id;
            }

            this[action](payload)
                .then((res) => {
                    this.items = res.data.termSignatures;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    created() {
        this.getData();
    },
    watch: {
        teacher() {
            this.getData();
        },
    },
};
</script>
